import { render, staticRenderFns } from "./AlbumCollaborators.vue?vue&type=template&id=27f71fee&scoped=true"
import script from "./AlbumCollaborators.vue?vue&type=script&lang=ts"
export * from "./AlbumCollaborators.vue?vue&type=script&lang=ts"
import style0 from "./AlbumCollaborators.vue?vue&type=style&index=0&id=27f71fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f71fee",
  null
  
)

export default component.exports